import {
  Create,
  DateField,
  Datagrid,
  Edit,
  EditButton,
  Filter,
  FunctionField,
  List,
  NumberInput,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  number,
  minValue,
  maxValue,
} from "react-admin";

const validatePercentage = [number(), minValue(0), maxValue(100)];

const percentageFormat = (value) => {
  const parsed = parseFloat(value);
  return !isNaN(parsed) ? `${Math.round(parsed * 100)}%` : "—";
};

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Supplier Name" source="name" alwaysOn />
  </Filter>
);

const SupplierList = (props) => (
  <List {...props} filters={<Filters />} bulkActionButtons={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Supplier Name" />
      <FunctionField
        source="percentagePhotovoltaic"
        label="% Photovoltaic"
        render={(record) => percentageFormat(record.percentagePhotovoltaic)}
      />
      <FunctionField
        source="percentageWind"
        label="% Wind"
        render={(record) => percentageFormat(record.percentageWind)}
      />
      <FunctionField
        source="percentageHydro"
        label="% Hydro"
        render={(record) => percentageFormat(record.percentageHydro)}
      />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
      <EditButton />
    </Datagrid>
  </List>
);

const ShowSupplier = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Supplier Name" />
      <FunctionField
        source="percentagePhotovoltaic"
        label="% Photovoltaic"
        render={(record) => percentageFormat(record.percentagePhotovoltaic)}
      />
      <FunctionField
        source="percentageWind"
        label="% Wind"
        render={(record) => percentageFormat(record.percentageWind)}
      />
      <FunctionField
        source="percentageHydro"
        label="% Hydro"
        render={(record) => percentageFormat(record.percentageHydro)}
      />
      <DateField source="createdAt" label="Created at" />
      <DateField source="updatedAt" label="Updated at" />
    </SimpleShowLayout>
  </Show>
);

const RenewableEnergyInputs = () => (
  <>
    <NumberInput
      source="percentagePhotovoltaic"
      label="% Photovoltaic"
      validate={validatePercentage}
      min={0}
      max={100}
    />
    <NumberInput
      source="percentageWind"
      label="% Wind"
      validate={validatePercentage}
      min={0}
      max={100}
    />
    <NumberInput
      source="percentageHydro"
      label="% Hydro"
      validate={validatePercentage}
      min={0}
      max={100}
    />
  </>
);

const CreateSupplier = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Supplier Name" />
      <RenewableEnergyInputs />
    </SimpleForm>
  </Create>
);

const EditSupplier = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="id" label="ID" disabled />
      <TextInput source="name" label="Supplier Name" />
      <RenewableEnergyInputs />
      <TextInput source="createdAt" label="Created at" disabled />
      <TextInput source="updatedAt" label="Updated at" disabled />
    </SimpleForm>
  </Edit>
);

const supplierResource = () => (
  <Resource
    name="supplier"
    options={{ label: "Historical Suppliers", menuGroup: "Suppliers" }}
    list={SupplierList}
    edit={EditSupplier}
    create={CreateSupplier}
    show={ShowSupplier}
  />
);

export default supplierResource;
